import { apiClient } from '../utils/apiClient';

export const dashboardService = {
  getSystemHealth: async () => {
    try {
      const response = await apiClient.get('/health');
      return response.data;
    } catch (error) {
      console.error('Error fetching system health', error);
      
      // Return mock data for development
      return {
        status: 'healthy',
        timestamp: Date.now(),
        version: '1.0.0',
        environment: 'development'
      };
    }
  },
  
  getModelPerformance: async (market = 'all', period = '7d') => {
    try {
      const response = await apiClient.get('/api/v1/predictions/performance', {
        params: { market, period }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching model performance', error);
      
      // Return mock data for development
      return {
        overall_accuracy: 76.8,
        by_market: {
          '1x2': 78.2,
          'over_under': 75.5,
          'btts': 72.3
        },
        by_league: {
          'premier_league': 82.4,
          'bundesliga': 78.1,
          'serie_a': 75.3,
          'la_liga': 79.6
        },
        trend: [
          { date: '2025-03-24', accuracy: 75.2 },
          { date: '2025-03-25', accuracy: 76.5 },
          { date: '2025-03-26', accuracy: 74.8 },
          { date: '2025-03-27', accuracy: 77.1 },
          { date: '2025-03-28', accuracy: 78.3 },
          { date: '2025-03-29', accuracy: 76.9 },
          { date: '2025-03-30', accuracy: 76.8 }
        ]
      };
    }
  },
  
  getLivePredictions: async (limit = 10) => {
    try {
      const response = await apiClient.get('/api/v1/predictions', {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching live predictions', error);
      
      // Return mock data for development
      return {
        predictions: [
          {
            id: '1',
            match: 'Manchester United vs Liverpool',
            league: 'Premier League',
            prediction: 'Home Win',
            confidence: 67.5,
            value: true,
            kickoff: new Date(Date.now() + 3600000).toISOString()
          },
          {
            id: '2',
            match: 'Bayern Munich vs Dortmund',
            league: 'Bundesliga',
            prediction: 'Over 2.5',
            confidence: 83.2,
            value: true,
            kickoff: new Date(Date.now() + 7200000).toISOString()
          },
          {
            id: '3',
            match: 'Barcelona vs Real Madrid',
            league: 'La Liga',
            prediction: 'Away Win',
            confidence: 58.7,
            value: false,
            kickoff: new Date(Date.now() + 5400000).toISOString()
          }
        ],
        count: 3
      };
    }
  },
  
  getSystemResources: async () => {
    try {
      // Assuming you have a system resources endpoint
      const response = await apiClient.get('/api/v1/system/resources');
      return response.data;
    } catch (error) {
      console.error('Error fetching system resources', error);
      
      // Return mock data for development
      return {
        cpu_usage: 45.3,
        memory_usage: 62.8,
        disk_usage: 73.1,
        network_throughput: 12.6,
        gpu_usage: 78.5,
        worker_nodes: 4,
        active_nodes: 4,
        timestamp: Date.now()
      };
    }
  },
  
  getApiHealth: async () => {
    try {
      const response = await apiClient.get('/api/v1/system/api-health');
      return response.data;
    } catch (error) {
      console.error('Error fetching API health', error);
      
      // Return mock data for development
      return {
        status: 'healthy',
        response_time: 125,
        error_rate: 0.2,
        request_count: 156782,
        endpoints: [
          { name: '/api/v1/predictions', status: 'healthy', response_time: 145 },
          { name: '/api/v1/matches', status: 'healthy', response_time: 112 },
          { name: '/api/v1/odds', status: 'degraded', response_time: 287 },
          { name: '/api/v1/users', status: 'healthy', response_time: 98 }
        ]
      };
    }
  },
  
  // For telemetry data from OpenTelemetry
  getTelemetryMetrics: async (service = 'all', timeRange = '1h') => {
    try {
      const response = await apiClient.get('/api/v1/observability/metrics', {
        params: { service, timeRange }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching telemetry metrics', error);
      
      // Return mock data for development
      return {
        services: [
          {
            name: 'betting-api',
            status: 'healthy',
            request_count: 12453,
            error_count: 23,
            average_response_time: 132
          },
          {
            name: 'prediction-service',
            status: 'healthy',
            request_count: 5621,
            error_count: 12,
            average_response_time: 215
          },
          {
            name: 'data-collector',
            status: 'degraded',
            request_count: 3254,
            error_count: 78,
            average_response_time: 432
          }
        ],
        metrics: {
          cpu_usage: [42, 45, 43, 47, 46, 44, 45],
          memory_usage: [58, 62, 65, 63, 61, 64, 63],
          request_rate: [95, 105, 112, 98, 103, 110, 106],
          error_rate: [0.2, 0.3, 0.2, 0.1, 0.3, 0.2, 0.2]
        },
        time_points: [
          Date.now() - 3600000,
          Date.now() - 3000000,
          Date.now() - 2400000,
          Date.now() - 1800000,
          Date.now() - 1200000,
          Date.now() - 600000,
          Date.now()
        ]
      };
    }
  }
};
